window.addEventListener("DOMContentLoaded", function () {
  var isTypeurl = window.location.href;
  if(isTypeurl.indexOf("products") != -1){
      setTimeout(AddSize, 1000);
  setTimeout(productCus, 1000);
  }


      $(".size-cm").click(function () {
    $(this).addClass("size_checked");
    $("#inTable").addClass("size_hidden");
    $("#cmTable").removeClass("size_hidden");
    $(".size-in").removeClass("size_checked");
  });

  $(".size-in").click(function () {
    $(this).addClass("size_checked");
    $("#cmTable").addClass("size_hidden");
    $("#inTable").removeClass("size_hidden");
    $(".size-cm").removeClass("size_checked");
  });

    var makeupTheDifferenceQty = '';
  if(getUrlParam('_qty') !=null){
    makeupTheDifferenceQty = getUrlParam('_qty');
  }else{
     makeupTheDifferenceQty = getUrlParam('_amount');
  }
  if (makeupTheDifferenceQty != null) {
    $("input[name='quantity']").val(makeupTheDifferenceQty);
  }
  })

function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
      , r = window.location.search.substr(1).match(reg);
    return r != null ? unescape(r[2]) : null
}

function AddSize() {
    var obj = $("div[class='bigtur_wrapper bigtur_simple bigtur_default']:has(select[label_value])");
    console.log(obj);
    var modal = '<a class="sizechartlabel" data-toggle="modal" data-target="#modalProductInfo" href="#" style="padding: 10px;display:inline-block;"><span class="icon-f-09"></span> Size guide</a>';
    typeof obj.html() == "undefined" || obj == null ? setTimeout(AddSize, 1e3) : obj.each(function() {
        obj.find(".bigtur_title").text().indexOf("Size") > -1 && $(this).find("div").eq(1).append(modal)
    })
}

function productCus() {
  var _upload = $("input[name='properties[Upload Logo]'] ,input[name='properties[Upload Photo]'] ");
  if (_upload.attr("data-price") != null) {
    _upload.attr("accept", "image/png, image/jpeg,image/jpg");
    if (_upload.parent().html().indexOf("Upload Your Photo") <= -1) {
      $("span[class='bigtur_title']").each(function () {
        var htm = $(this).html();
        var title = $(this).text();
        if (htm.indexOf("Team Logo") > -1 || htm.indexOf("Back Logo") > -1 ||  htm.indexOf('Front - Your Picture') > -1) {
          htm =
            '<font size="-2">（Upload a file no less than 800px by 800px in AI, PDF, PNG, JPG format.）</font>';
          $(this).append(htm);
        }else if($(this).parents('.bigtur_simple ').find('textarea').length == 1){
          if(htm.indexOf("Text 1") > -1){
            html2 = "DAD <br> YOU'RE OUR <br> HOME RUN"
          }else if(htm.indexOf("Age") > -1 ||  htm.indexOf("Time") > -1){
                   html2 = "1984 <br> 40"
          }else if(htm.indexOf("Year") > -1){
                   html2 = "1974<br>50"
          }
         $(this).parents('.bigtur_simple ').find('.bigtur_div_extend').addClass('active').html(html2)
        $(this).parents('.bigtur_simple ').find('textarea').bind('input propertychange', function() {
            var textareaValue = $(this).val().trim();
            if (textareaValue === '') {
             $(this).next('div').html(html2)
              } else {
               $(this).next('div').empty()
             }
            });
        }else if(htm.indexOf("Text") > -1 && $(this).parents('.bigtur_simple ').find('textarea').length == 1){
         $(this).parents('.bigtur_simple ').find('.bigtur_div_extend').addClass('active').html("HAPPY <br> Grandparents <br> DAY")

        $(this).parents('.bigtur_simple ').find('textarea').bind('input propertychange', function() {
            var textareaValue = $(this).val().trim();
            if (textareaValue === '') {
             $(this).next('div').html("HAPPY <br> Grandparents <br> DAY")
              } else {
               $(this).next('div').empty()
             }
            });
        }
       
        
      });
    }
  } else {
    setTimeout(productCus, 100);
  }
}